<div class="card">
    <app-header titulo="Parametrização" descricao="Parametros das integrações"></app-header>

    <div class="mt-3">
        <p-table #dtparam [globalFilterFields]="['secao','entrada','valor','descricao']" [value]="parametros" dataKey="id" editMode="row"  styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [resizableColumns]="true" [breakpoint]="'960px'" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="400px">
            <ng-template pTemplate="caption">
                <div class="flex">
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dtparam.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="max-width:10%">Instância</th>
                    <th style="max-width:15%">Seção</th>
                    <th style="max-width:15%">Entrada</th>
                    <th style="max-width:15%">Tipo</th>
                    <th pResizableColumn>Valor</th>
                    <th pResizableColumn>Descrição</th>
                    <th pFrozenColumn [frozen]="true"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-parametro let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="parametro">
                    <td>
                        {{ parametro.instancia }}
                    </td>
                    <td>{{ parametro.secao }}
                </td>
                    <td>{{ parametro.entrada }}</td>
                    <td><p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="parametro.tipo" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ parametro.tipo }}
                        </ng-template>
                    </p-cellEditor></td>
                    <td><p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="parametro.valor" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ parametro.valor }}
                        </ng-template>
                    </p-cellEditor></td>
                    <td><p-cellEditor>
                        <ng-template pTemplate="input">
                            <textarea pInputTextarea rows="4" cols="30" [(ngModel)]="parametro.descricao" required></textarea>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ parametro.descricao }}
                        </ng-template>
                    </p-cellEditor></td>
                    <td alignFrozen="right" pFrozenColumn [frozen]="true">
                        <p-button *ngIf="!editing" icon="pi pi-pencil" [rounded]="true" pInitEditableRow [text]="true" severity="info" (click)="editar(parametro)" aria-label="Editar"></p-button>
                        <!-- <p-button *ngIf="!editing && parametro.ativo" icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (click)="desativar(parametro)" aria-label="Desativar"></p-button>
                        <p-button *ngIf="!editing && !parametro.ativo" icon="pi pi-check" [rounded]="true" [text]="true" severity="success" (click)="ativar(parametro)" aria-label="Ativar"></p-button> -->

                        <p-button *ngIf="editing" icon="pi pi-check" [rounded]="true" pSaveEditableRow [text]="true" severity="info" (click)="salvar(parametro)" aria-label="Salvar"></p-button>
                        <p-button *ngIf="editing" icon="pi pi-times" [rounded]="true" pCancelEditableRow [text]="true" severity="danger" (click)="cancelar(parametro, ri)" aria-label="Cancelar"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">Parâmetros não encontrados</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    
</div>